var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4778 16H22.6719V46.2008H39.4778V16Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7402 31.1013C23.7375 28.1928 24.3966 25.3218 25.6676 22.7056C26.9386 20.0894 28.788 17.7967 31.0761 16.001C28.2427 13.7738 24.8398 12.3888 21.2565 12.0042C17.6732 11.6196 14.0539 12.251 10.8125 13.826C7.57097 15.4011 4.83801 17.8564 2.92599 20.9113C1.01396 23.9662 0 27.4974 0 31.1013C0 34.7053 1.01396 38.2365 2.92599 41.2914C4.83801 44.3462 7.57097 46.8016 10.8125 48.3767C14.0539 49.9517 17.6732 50.5831 21.2565 50.1985C24.8398 49.8139 28.2427 48.4289 31.0761 46.2017C28.7881 44.406 26.9386 42.1133 25.6676 39.4971C24.3967 36.8809 23.7376 34.0099 23.7402 31.1013Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1493 31.1013C62.1495 34.7052 61.1356 38.2364 59.2237 41.2913C57.3118 44.3462 54.5789 46.8015 51.3375 48.3766C48.0961 49.9517 44.4769 50.5831 40.8936 50.1985C37.3103 49.8139 33.9075 48.4289 31.0742 46.2017C33.3602 44.4042 35.2083 42.1111 36.479 39.4953C37.7498 36.8796 38.41 34.0094 38.41 31.1013C38.41 28.1932 37.7498 25.3231 36.479 22.7074C35.2083 20.0916 33.3602 17.7985 31.0742 16.0009C33.9075 13.7738 37.3103 12.3888 40.8936 12.0042C44.4769 11.6196 48.0961 12.251 51.3375 13.8261C54.5789 15.4012 57.3118 17.8565 59.2237 20.9114C61.1356 23.9663 62.1495 27.4975 62.1493 31.1013Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3192 43.0033V42.385H60.5685V42.259H59.9336V42.385H60.183V43.0033H60.3192ZM61.5519 43.0033V42.2578H61.3573L61.1334 42.7706L60.9095 42.2578H60.7148V43.0033H60.8522V42.441L61.0622 42.9258H61.2047L61.4146 42.4397V43.0033H61.5519Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.94e56b60540051e0ef24ee9b03f1f2e6.svg";
export { ForwardRef as ReactComponent };